/**
 * UI plugins (Vuetify, router, masks, notifications).
 * Domain globals ($API, constants) are installed separately via installGlobals.
 */
import { loadFonts } from './webfontloader'
import vuetify from './vuetify'
import VueTheMask from 'vue-the-mask'
import Notifications from '@kyvg/vue3-notification'
import router from '../router'

export function registerPlugins(app) {
  loadFonts()
  app
    .use(vuetify)
    .use(router)
    .use(VueTheMask)
    .use(Notifications)
}

export { installGlobals } from './globals'
export { installFilters } from './filters'

